export default __webpack_public_path__ + "static/tablet-7ab6edebae84cecfd32a01cbf4b1fe8a.png";